var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5577 0.952381L12.4413 3.06878H2.1164V17.8836H16.9312V7.55873L19.0476 5.44233V18.9418C19.0476 19.2225 18.9361 19.4916 18.7377 19.6901C18.5392 19.8885 18.2701 20 17.9894 20H1.0582C0.777549 20 0.508391 19.8885 0.30994 19.6901C0.111489 19.4916 0 19.2225 0 18.9418V2.01058C0 1.72993 0.111489 1.46077 0.30994 1.26232C0.508391 1.06387 0.777549 0.952381 1.0582 0.952381H14.5577ZM18.5026 0L20 1.49841L10.273 11.2254L8.77884 11.2286L8.77672 9.7291L18.5026 0Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNew);
export default __webpack_public_path__ + "static/media/edit-new.8496d9b1826774afa56d9edbf3206791.svg";
export { ForwardRef as ReactComponent };